import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAdapter } from '../../../config/api';
var updateContactPreference = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _contact$contact_pref;
    var contact, formValues, contactPreferenceId, personId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          contact = _ref.contact, formValues = _ref.formValues;
          contactPreferenceId = (_contact$contact_pref = contact.contact_preference) === null || _contact$contact_pref === void 0 ? void 0 : _contact$contact_pref.id;
          personId = contact.id;
          if (!contactPreferenceId) {
            _context.next = 8;
            break;
          }
          _context.next = 6;
          return getAdapter('coreApi').updateRecord('contact_preference', contactPreferenceId, formValues);
        case 6:
          _context.next = 10;
          break;
        case 8:
          _context.next = 10;
          return getAdapter('coreApi').createRecord('contact_preference', _objectSpread(_objectSpread({}, formValues), {}, {
            person: personId
          }));
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function updateContactPreference(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default updateContactPreference;
//# sourceMappingURL=updateContactPreference.js.map